import React from 'react';
import styles from './DescribeSection.module.css';
import image from './images/ai.png';
import {
    OptimizedMotionH1,
    OptimizedMotionP,
} from '../../../shared/ui/optimized-motion/OptimizedMotion';

const DescribeSection: React.FC = () => {
    return (
        <div className={styles.container}>
            <img src={image} alt="describe" className={styles.image} />
            <div>
                <OptimizedMotionH1 className={styles.title} type="slide-down" delay={0.2}>
                    AI‑Assisted Craftsmanship
                </OptimizedMotionH1>
                <OptimizedMotionP className={styles.description} type="slide-left" delay={0.4}>
                    Copywriters get predictive sentence completions in brand tone, while designers
                    access AI prompts that expand, remix, or resize visuals in seconds. The AI never
                    replaces creativity; it removes the grunt work so humans can focus on big ideas.
                </OptimizedMotionP>
            </div>
            <div className={styles.blur}></div>
        </div>
    );
};

export default DescribeSection;
